import { dayjs } from 'utils/providers/Timezone';

const getDaysLeft = (expiresAt: string) => {
  const days = dayjs(expiresAt).diff(dayjs(), 'days');

  if (days <= 0) {
    return 0;
  }

  return days;
};

type ARGS = {
  data: {
    status: string;
    expiresAt: string;
    isExpires: boolean;
    daysLeft: number;
  };
};

const subscription = ({ data: { status, expiresAt, ...rest } }: ARGS) => ({
  data: {
    ...rest,
    status,
    isExpired: status !== 'ACTIVE',
    expiresAt,
    daysLeft: getDaysLeft(expiresAt),
  },
});

export default subscription;
